import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function Terms() {
  return (
    <div className="min-h-screen bg-brand-dark">
      <div className="max-w-4xl mx-auto px-4 py-12">
        <Link to="/" className="inline-flex items-center text-brand-gold hover:text-yellow-400 mb-8">
          <ArrowLeft size={20} className="mr-2" /> Back to Home
        </Link>
        
        <div className="glass-card rounded-2xl p-8 md:p-12">
          <h1 className="text-3xl md:text-4xl font-bold text-brand-gold mb-2">Terms & Conditions</h1>
          <p className="text-gray-400 mb-8">Effective Date: January 1, 2025</p>
          
          <div className="prose prose-invert max-w-none">
            <p className="text-gray-300 mb-6">
              <strong className="text-white">Economic Club of San Antonio ("ECSA," "we," "us")</strong>
            </p>
            <p className="text-gray-300 mb-8">
              By accessing our website, applying for membership, attending events, or using any ECSA platform, you agree to these Terms.
            </p>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-brand-gold mb-4">1) Purpose & Conduct</h2>
              <p className="text-gray-300">
                ECSA is a professional community focused on economic dialogue and sound business principles. Members and users must act with integrity and professionalism. Prohibited conduct includes fraud, deception, harassment, exploitation, or any behavior inconsistent with ECSA standards. We may deny, suspend, or terminate access/membership for violations.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-brand-gold mb-4">2) Membership & Events</h2>
              <p className="text-gray-300">
                Membership is discretionary. Events, speakers, venues, and schedules may change. Some events require fees; unless stated otherwise at checkout/RSVP, fees are non-refundable and non-transferable.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-brand-gold mb-4">3) User Content & Submissions</h2>
              <p className="text-gray-300">
                If you submit information/content (e.g., profile details, RSVPs, messages), you represent you have the right to share it. You grant ECSA a non-exclusive license to use it for Club operations, including networking features and sponsor/affiliate programs as described in the Privacy Policy.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-brand-gold mb-4">4) Third Parties</h2>
              <p className="text-gray-300">
                ECSA may reference or host third-party speakers, sponsors, affiliates, and links. ECSA does not control or guarantee third-party statements, products, services, or outcomes.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-brand-gold mb-4">5) No Professional Advice</h2>
              <p className="text-gray-300">
                ECSA content and events are for informational and networking purposes only and are not legal, tax, or investment advice.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-brand-gold mb-4">6) Limitation of Liability</h2>
              <p className="text-gray-300">
                To the fullest extent permitted by law, ECSA is not liable for indirect, incidental, consequential, or punitive damages arising from use of the website, events, membership, or member-to-member interactions.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-brand-gold mb-4">7) Indemnification</h2>
              <p className="text-gray-300">
                You agree to indemnify and hold ECSA harmless from claims arising from your use of the services, submissions, interactions, or violation of these Terms.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-brand-gold mb-4">8) Governing Law</h2>
              <p className="text-gray-300">
                Texas law governs these Terms. Venue: Bexar County, Texas, unless otherwise required by law.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-brand-gold mb-4">9) Changes & Contact</h2>
              <p className="text-gray-300">
                We may update these Terms. Continued use means acceptance of updates.
              </p>
              <p className="text-gray-300 mt-4">
                <strong className="text-white">Contact:</strong> <a href="mailto:mau@mausanchez.com" className="text-brand-gold hover:underline">mau@mausanchez.com</a>
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
